export default Object.freeze({
  nutzungsbedingungen: window.location.origin + '/dokumente/AGB_Gutachtenportal.pdf',
  datenschutzerklaerung: 'https://www.sprengnetter.de/datenschutz/',
  products: {
    Kaufpreisaufteilung: {
      leitfadenLink: window.location.origin + '/dokumente/leitfaeden/Leitfaden_Kaufpreisaufteilung.pdf',
      leistungsbeschreibungLink: window.location.origin + '/dokumente/Leistungsbeschreibung_Kaufpreisaufteilung.pdf'
    },
    Nutzungsdauergutachten: {
      leitfadenLink: window.location.origin + '/dokumente/leitfaeden/Leitfaden_Nutzungsdauergutachten.pdf',
      leistungsbeschreibungLink: window.location.origin + '/dokumente/Leistungsbeschreibung_Nutzungsdauergutachten.pdf'

    }
  },
});